import { GoogleMap, Marker } from "@react-google-maps/api";

type Coord = { lat: number; lng: number };

type Props = {
  center: Coord;
  onMarkerDragEnd?: (lat: number, lng: number) => void;
};

const mapContainerStyle: React.CSSProperties = {
  width: "100%",
  height: "100%",
};

const mapOptions: google.maps.MapOptions = {
  mapTypeControl: false,
  streetViewControl: false,
  zoomControl: true,
};

/** Mapa con pin arrastrable (API cargada en index.html). */
export function StoreLocationMap({ center, onMarkerDragEnd }: Props) {
  const googleReady =
    typeof window !== "undefined" &&
    Boolean((window as unknown as { google?: { maps?: unknown } }).google?.maps);

  if (!googleReady) {
    return (
      <div
        style={{
          height: 220,
          background: "#f8fafc",
          borderRadius: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#94a3b8",
          fontSize: 13,
        }}
      >
        Cargando mapa…
      </div>
    );
  }

  return (
    <div
      style={{
        height: 220,
        width: "100%",
        position: "relative",
        borderRadius: 10,
        overflow: "hidden",
        border: "1px solid #e8edf2",
      }}
    >
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={center}
        zoom={16}
        options={mapOptions}
      >
        <Marker
          position={center}
          draggable
          onDragEnd={(event) => {
            const lat = event.latLng?.lat();
            const lng = event.latLng?.lng();
            if (lat != null && lng != null) {
              onMarkerDragEnd?.(lat, lng);
            }
          }}
        />
      </GoogleMap>
    </div>
  );
}
